import { render, staticRenderFns } from "./newTopicDialog.vue?vue&type=template&id=7088c83e&scoped=true&"
import script from "./newTopicDialog.vue?vue&type=script&lang=js&"
export * from "./newTopicDialog.vue?vue&type=script&lang=js&"
import style0 from "./newTopicDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7088c83e",
  null
  
)

export default component.exports